import { usePersistedSessionState } from '@edreamsodigeo/frontend-core';

const useAlternativeFlight = () => {
  const [alternativeFlight, setAlternativeFlight] =
    usePersistedSessionState('alternativeFlight');

  return { alternativeFlight, setAlternativeFlight };
};

export default useAlternativeFlight;
